import { SESSIONID_KEY } from "@/constants";

export const getSessionId = () => sessionStorage.getItem(SESSIONID_KEY) ?? "";
export const setSessionId = (sessionId: string | undefined) =>
  sessionStorage.setItem(SESSIONID_KEY, sessionId ?? "");
